<template>
    <div>
        <v-row>
            <v-col cols="2">
                <div>
                  <v-btn to="custom-page-content-create" color="blue" class="mb-2" block>Utwórz stronę</v-btn>
                    <div>
                        <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="titleFilter"
                                    label="Tytuł"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                        </v-menu>
                        <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="urlFilter"
                                    label="URL"
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                        </v-menu>
                        <v-menu
                            v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-autocomplete
                                    v-model="categoryFilter"
                                    :items="categories"
                                    :menu-props="{ maxHeight: '400' }"
                                    item-text="name"
                                    item-value="id"
                                    label="Kategoria"
                                    multiple
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-autocomplete>
                            </template>
                        </v-menu>
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-autocomplete
                                    v-model="cityFilter"
                                    :items="cities"
                                    :menu-props="{ maxHeight: '400' }"
                                    item-text="name"
                                    item-value="id"
                                    label="Miasto"
                                    multiple
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-autocomplete>
                            </template>
                        </v-menu>
                        <v-checkbox v-model="noCityFilter"
                                    v-bind="attrs"
                                    v-on="on"
                                    label="Brak miasta"
                        ></v-checkbox>
                    </div>
                </div>
            </v-col>
            <v-col cols="10">
                <data-table
                    ref="table"
                    :headers="headers"
                    :items="pageContents"
                    :options.sync="options"
                    :server-items-length="totalPageContents"
                    :loading="loading"
                    class="row-pointer"
                    @click:row="onRowClicked"
                >
                  <template v-slot:item.id="{ item }">
                    <span @click.stop><a :href="landingBaseUrl + '/s/' + item.slug" target="_blank">{{ landingBaseUrl }}/s/{{ item.slug }}</a></span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn class="red mt-2" @click.stop="deletePage(item, $event)" depressed>
                      <v-icon dark>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from '../services/api';
import debounce from 'debounce';
import DataTable from "@/components/data-table/DataTable";
import formatters from '@/mixins/formatters';
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import permissions from '@/mixins/permissions';

export default {
    mixins: [
        formatters,
        permissions,
    ],
    components: {
        DataTable,
    },
    data() {
        return {
            landingBaseUrl: process.env.VUE_APP_LANDING_URL,
            pageContents: [],
            totalPageContents: 0,
            loading: true,
            options: {},
            headers: [
                {text: 'Tytuł', value: 'title', sortable: false},
                {text: 'URL', value: 'id', sortable: false},
                {text: 'Akcje', value: 'actions', sortable: false},
            ],
            menu1: false,
            menu2: false,
            filters: {
                city: null,
                category:null,
            },
            cityFilter: null,
            categoryFilter: null,
            titleFilter: null,
            urlFilter: null,
            noCityFilter: null,
            cities: [],
            categories: []
        }
    },
    watch: {
        options: {
            handler() {
                this.getPageContents();
                setDatatableOptions.call(this);
            },
            deep: true,
        },
        categoryFilter() {
            this.getOffersFilteredByCategory();
        },
        titleFilter() {
            this.getOffersFilteredByTitle();
        },
        urlFilter() {
            this.getOffersFilteredByUrl();
        },
        cityFilter() {
            this.getOffersFilteredByCity();
        },
        noCityFilter() {
            this.getOffersFilteredByNoCity();
        },
    },
    methods: {
        async getPageContents() {
            const {page, itemsPerPage} = this.options;

            this.loading = true;

            const params = {
                offset: page > 1 ? itemsPerPage * (page - 1) : 0
            };

            if (-1 !== itemsPerPage) {
                params.limit = itemsPerPage;
            }

            if (this.categoryFilter) {
                params.category = this.categoryFilter;
            } else {
                delete params.category;
            }

            if (this.titleFilter) {
                params.title = this.titleFilter;
            } else {
                delete params.title;
            }

            if (this.urlFilter) {
                params.slug = this.urlFilter.split('/').slice(-1).pop();
            } else {
                delete params.slug;
            }

            if (this.cityFilter) {
                params.city = this.cityFilter;
            } else {
                delete params.city;
            }

            if (this.noCityFilter) {
                params.withoutCity = true;
            } else {
                delete params.withoutCity;
            }
            const response = await api.get('/api/custom-page-content', {params});
            this.loading = false;

            this.pageContents = response.data.items;
            this.totalPageContents = response.data.total;
        },
        async getCategories() {
            const response = await api.get('/api/categories?level=0');
            this.categories = response.data.categories;
        },
        async getCities() {
            const response = await api.get('/api/cities?size=B,M');
            this.cities = response.data.cities;
        },
        onRowClicked(pageContent) {
            this.$router
                .push({name: 'custom-page-content-details', params: {id: pageContent.id}})
                .catch((error) => {
                    if (String(error).includes('Avoided redundant navigation to current location')) {
                        return;
                    }

                    throw error;
                });
        },
        async deletePage(item) {
          await api.delete(`/api/custom-page-content/${item.id}`);
          this.getPageContents();
        }
    },
    created() {
        getDatatableParams.call(this);
        this.getCategories();
        this.getCities();
        this.getOffersFilteredByCategory = debounce(function () {
            this.getPageContents();
        }, 500);
        this.getOffersFilteredByCity = debounce(function () {
            this.getPageContents();
        }, 500);
        this.getOffersFilteredByNoCity = debounce(function () {
            this.getPageContents();
        }, 500);
        this.getOffersFilteredByTitle = debounce(function () {
            this.getPageContents();
        }, 500);
        this.getOffersFilteredByUrl = debounce(function () {
            this.getPageContents();
        }, 500);
    }
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>